module.exports = __webpack_public_path__ + "static/media/hamburg.573ad919.png";